import { axiosIntance } from "./config"

export const getAllFolder = async()=>{
    const response = await axiosIntance.get('/nodes')
    return response.data
}
export const postFolder = async (data, onProgress) => {
//   const formData = new FormData();

//   for (const key in data) {
//     if (key === 'file' && data[key]) {
//       formData.append('file', data[key]);
//     } else {
//       formData.append(key, data[key]);
//     }
//   }

  const response = await axiosIntance.post('/nodes', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percentCompleted);
      }
    },
  });

  return response.data;
};

export const getFolder = async(id)=>{
    const response = await axiosIntance.get(`/nodes/${id}`)
    return response.data
}

/* export const updateFolder = async(id)=>{
    const response = await axiosIntance.put(`/nodes/${id}`)
    return response.data
} */

   export const updateFolder = async (id, name) => {
  const response = await axiosIntance.put(`/nodes/${id}`, {
    name, 
  });
  return response.data;
};




export const deleteFolder = async(id)=>{
    const response = await axiosIntance.delete(`/nodes/${id}`)
    return response.data
}



export const getBinData = async()=>{
    const response = await axiosIntance.get(`/bin/nodes`)
    return response.data
}




